import { Link } from "react-router-dom";
import { useAuth } from "./useAuth";
import VotingAsGuestBanner from "../features/scheduler/components/voting-as-guest-banner";

// Lightweight shell for anonymous guests on a link-shared scheduler route.
// Deliberately does NOT mount the personal app shell: no `useNotificationSync`,
// no `NotificationBell`, no account menu, no profile nav. A guest is a voter
// only — their presence must not leak into account/notification state. The full
// `AppLayout` is rendered for real users by `SchedulerShell` (see App.jsx), so
// this component only mounts when `user.isAnonymous` (C4).
//
// `onSignIn` is the path to a real Google sign-in (wired by the route
// consumer); the banner surfaces it as "Make an account for free".
export default function GuestLayout({ children, onSignIn }) {
  const { user } = useAuth();
  return (
    <div className="relative min-h-full text-slate-900 dark:text-slate-100">
      <div className="absolute inset-0 -z-10">
        <div className="absolute inset-0 bg-[url('/assets/app-bg-light.jpeg')] bg-cover bg-center" />
        <div className="absolute inset-0 hidden bg-[url('/assets/app-bg-dark.jpeg')] bg-cover bg-center dark:block" />
        <div className="absolute inset-0 bg-gradient-to-b from-white/50 via-white/60 to-white/80 dark:from-slate-950/45 dark:via-slate-950/65 dark:to-slate-950/85" />
      </div>
      <header className="sticky top-0 z-40 border-b border-slate-200/70 bg-white/90 backdrop-blur dark:border-slate-700/70 dark:bg-slate-900/90">
        <div className="mx-auto flex max-w-6xl items-center justify-between px-6 py-4">
          <Link to="/scheduler" className="flex items-center gap-3" tabIndex={-1}>
            <img
              src="/app_icon.png"
              alt="Quest Scheduler Logo"
              className="h-9 w-9 rounded-xl object-contain"
            />
            <div>
              <p className="text-sm font-display font-semibold tracking-wide">
                Quest Scheduler
              </p>
            </div>
          </Link>
        </div>
      </header>
      <main className="mx-auto max-w-6xl px-6 py-6">
        <div className="space-y-4">
          {user?.isAnonymous ? (
            <VotingAsGuestBanner onSignIn={onSignIn} />
          ) : null}
          {children}
        </div>
      </main>
    </div>
  );
}
